import React from "react";

export default function Hero() {
  return (
    <section className="hero" id="top" aria-labelledby="hero-title">
      <div className="wrap">
        <div className="hero-grid">
          <div>
            <span className="eyebrow">Carpentry &amp; Construction &bull; Southern Maine &bull; Seacoast NH</span>
            <h1 id="hero-title">
              Small projects.<br />
              <em>Experienced<br />hands.</em>
            </h1>
            <p className="hero-copy">
              Doors, windows, decks, fences, sheds, finish woodworking, painting, core drilling, and concrete slabs. Owner-operated carpentry and construction for homeowners &mdash; and a reliable sub for builders and general contractors.
            </p>
            <div className="hero-actions">
              <a className="btn" href="#contact">Discuss your project <span aria-hidden="true">&rarr;</span></a>
              <a className="btn outline" href="#builders">For builders</a>
            </div>
            <p className="hero-note">Homeowners &amp; builders welcome. Southern Maine to the New Hampshire seacoast.</p>
          </div>
          <aside className="craft-card" aria-label="Our focus">
            <p className="craft-card-top">Homeowners &bull; Builders &bull; Subs</p>
            <p className="craft-statement">
              Good work.<br />Down to<br /><em>the details.</em>
            </p>
            <div className="craft-bottom">
              <p>Carpentry. Repairs.<br />Construction &amp; sub work.</p>
              <span className="craft-initials" aria-hidden="true">JKM</span>
            </div>
          </aside>
        </div>
        <div className="pillars">
          <span>Homeowners &amp; builders</span>
          <span>Fully insured LLC</span>
          <span>Clearly scoped projects</span>
        </div>
      </div>
    </section>
  );
}
